import { requests, mainApiRoot } from './index'

export const WebsiteAudit = {
  getAll: domainId => requests.get(mainApiRoot, `/domains/${domainId}/website-audit`),
  getLatest: domainId => requests.get(mainApiRoot, `/domains/${domainId}/website-audit/report`),
  get: (domainId, auditId) =>
    requests.get(mainApiRoot, `/domains/${domainId}/website-audit/${auditId}/report`),
  getCrawlData: (domainId, auditId) =>
    requests.get(mainApiRoot, `/domains/${domainId}/website-audit/${auditId}/crawled-pages`),
  export: (domainId, auditId) =>
    requests.get(mainApiRoot, `/domains/${domainId}/website-audit/${auditId}/export`),
  generateSitemap: (domainId) =>
    requests.get(mainApiRoot, `/domains/${domainId}/website-audit/sitemap-export`),
  restartAudit: (domainId) =>
    requests.post(mainApiRoot, `/domains/${domainId}/website-audit/`)
}
